"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zoomIn = exports.TransitionDurations = void 0;
var TransitionDurations;
(function (TransitionDurations) {
    TransitionDurations[TransitionDurations["FAST"] = 0.1] = "FAST";
    TransitionDurations[TransitionDurations["NORMAL"] = 0.2] = "NORMAL";
})(TransitionDurations = exports.TransitionDurations || (exports.TransitionDurations = {}));
const baseAnimationOptions = {
    initial: 'hidden',
    animate: 'visible',
    exit: 'hidden'
};
exports.zoomIn = Object.assign(Object.assign({}, baseAnimationOptions), { variants: {
        hidden: {
            opacity: 0,
            scale: 0.9
        },
        visible: {
            opacity: 1,
            scale: 1
        }
    }, transition: {
        duration: TransitionDurations.FAST,
        ease: 'easeOut'
    } });
